import { Button, ButtonProps } from '../button/button';

export function Submit(props: ButtonProps) {
  return <Button {...props} type="submit" />;
}
